import { Skeleton } from '@mantine/core'

interface TableSkeletonProps {
  /** Número de colunas (deve bater com o thead). */
  columns: number
  /** Número de linhas a simular. Default: 5. */
  rows?: number
  /** data-testid opcional para os testes existentes (mantém compat). */
  testId?: string
}

/**
 * Esqueleto que substitui "Carregando..." nas tabelas de listagem.
 *
 * Renderiza um <tbody> com `rows × columns` placeholders animados; mais
 * representativo do layout final que um spinner centralizado e ajuda a
 * reduzir layout shift quando os dados chegam.
 *
 * Mantém `aria-busy` + `aria-live="polite"` para que screen readers
 * continuem anunciando o estado de carregamento.
 */
export function TableSkeleton({ columns, rows = 5, testId }: TableSkeletonProps) {
  return (
    <tbody data-testid={testId} aria-busy="true" aria-live="polite">
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <tr key={rowIdx}>
          {Array.from({ length: columns }).map((_, colIdx) => (
            <td key={colIdx}>
              <Skeleton height={14} radius="sm" />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  )
}
